import {
  WaterQualityReading,
  WaterQualityThreshold,
  WaterQualityColor,
  WaterQualityStatus,
  getWaterQualityStatus,
  extractReadingValueFromSensorEvent,
  SensorType,
  getTimestampFormat,
} from 'common';
import { useTranslation } from 'react-i18next';
import { tokens, gradients } from 'tamagui-config';

import { useLatestSensorEvents } from '../sensors/useLatestSensorEvent';

export const waterQualityColorTokens = {
  [WaterQualityColor.Red]: {
    gradientStart: tokens.color.warningRed,
    gradientEnd: tokens.color.warningRed,
    backgroundGradients: gradients.error,
  },
  [WaterQualityColor.Yellow]: {
    gradientStart: tokens.color.warning,
    gradientEnd: tokens.color.warning,
    backgroundGradients: gradients.warning,
  },
  [WaterQualityColor.Blue]: {
    gradientStart: tokens.color.waterGradientStart,
    gradientEnd: tokens.color.waterGradientEnd,
    backgroundGradients: gradients.blue,
  },
};

export const useGetWaterQualityData = (): WaterQualityStatus | null => {
  const { t } = useTranslation();
  const { event } = useLatestSensorEvents(SensorType.WATER_QUALITY);
  if (!event) return null;

  const value = extractReadingValueFromSensorEvent<WaterQualityReading>(event)?.ec;
  if (value === undefined) return null;

  const status = getWaterQualityStatus(value, (threshold) => {
    switch (threshold) {
      case WaterQualityThreshold.excellent:
        return t('water.quality.excellent');
      case WaterQualityThreshold.good:
        return t('water.quality.good');
      case WaterQualityThreshold.fair:
        return t('water.quality.fair');
      case WaterQualityThreshold.poor:
        return t('water.quality.poor');
      case WaterQualityThreshold.veryPoor:
        return t('water.quality.veryPoor');
    }
  });

  if (!status.lastReported) {
    status.lastReported = event?.timestamp
      ? getTimestampFormat(event.timestamp * 1000)
      : 'Invalid Time';
  }

  return status;
};
